module.exports = __webpack_public_path__ + "static/media/spot14.48e16441.webp";